import { render, staticRenderFns } from "./RolesLista.vue?vue&type=template&id=2911bfbd&"
import script from "./RolesLista.vue?vue&type=script&lang=ts&"
export * from "./RolesLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports